import styled from '@emotion/styled';
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { Color } from '../../../features/shared/styles/Color';
import type { ITheme } from '../../themer';
import themed from '../../themer/themed';
import { StyledButton } from './Button';

export interface IIconButtonProps
	extends ButtonHTMLAttributes<HTMLButtonElement> {
	inverted?: boolean;
	secondary?: boolean;
	children: ReactNode;
}

function getStrokeColor(state: 'hover' | 'default') {
	return themed<IIconButtonProps>(({ button }, { secondary, inverted }) => {
		const type = secondary ? 'secondary' : 'primary';
		const baseTheme = button[type];
		const variationTheme = inverted ? baseTheme.inverted : baseTheme;
		const stateTheme =
			state === 'hover' ? variationTheme.hover : variationTheme;

		return stateTheme.font.color;
	});
}

const textWhiteOpacity = `rgba(255, 255, 255, 0.6)`;

export const StyledIconButton = styled(StyledButton)<IIconButtonProps, ITheme>`
	display: inline-flex;
	align-items: center;
	font-family: ${themed(({ typography }) => typography.body.fontFamily)};

	&:disabled {
		background: ${Color.PrimaryDefault};
		border-color: ${Color.PrimaryDefault};
		color: ${textWhiteOpacity}; // text opacity
		opacity: 1;

		svg {
			g {
				stroke: ${textWhiteOpacity};
			}
		}
	}

	svg {
		flex-grow: 0;
		flex-shrink: 0;
		height: ${themed(({ button }) => button.iconSize)};
		margin-left: ${themed(({ button }) => button.iconSeparator)};
	}

	g {
		stroke: ${getStrokeColor('default')};
	}

	&:hover {
		g {
			stroke: ${getStrokeColor('hover')};
		}
	}

	&:focus-visible {
		z-index: 1;
	}
`;
